import { List } from '@zxing/library/esm/customTypings';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { SupplementaryEquipmentDetails, SupplementaryEquipmentIdentifier } from '../../model/supplementary-equipment-details';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';

@Component({
  selector: 'app-equipment-identifier',
  templateUrl: './equipment-identifier.component.html',
  styleUrls: ['./equipment-identifier.component.scss']
})
export class EquipmentIdentifierComponent implements OnInit {

  @Input() selectedDetails: SupplementaryEquipmentDetails;

  @Output() deleteClicked = new EventEmitter<SupplementaryEquipmentIdentifier>();

  @Output() changeActiveClicked = new EventEmitter<SupplementaryEquipmentIdentifier>();

  @Output() addNewIdentifierClicked = new EventEmitter<SupplementaryEquipmentIdentifier>();


  identifiers: List<SupplementaryEquipmentIdentifier>;

  identifiersForm: FormGroup;

  newIdentifier: string;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedDetails == null) {
      return;
    }
    this.identifiers = changes.selectedDetails.currentValue.identifiers ?? new Array<SupplementaryEquipmentIdentifier>();;
  }


  constructor(public translationService: TranslationService, private dialog: MatDialog) {
    this.identifiersForm = new FormGroup({
      newIdentifier: new FormControl("", [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.identifiers = this.selectedDetails.identifiers ?? new Array<SupplementaryEquipmentIdentifier>();

    this.identifiersForm.valueChanges.subscribe(value => {
      this.newIdentifier = value.newIdentifier;
    }
    );
  }

  changeActive(identifier: SupplementaryEquipmentIdentifier) {
    identifier.active = !identifier.active;
    this.changeActiveClicked.emit(identifier);

  }

  delete(
    identifier: SupplementaryEquipmentIdentifier
  ) {
    const dialogData: ConfirmDialogData = {
      titleKey:
        "tmc-common.ui.supplementary-equipment.delete.confirm-dialog.title",
      messageKey:
        "tmc-common.ui.supplementary-equipment.delete.confirm-dialog.message",
      confirm: () => {
        this.identifiers = this.identifiers.filter((oldIdentifier) => oldIdentifier.identifier != identifier.identifier);
        console.log(identifier, this.identifiers)
        this.deleteClicked.emit(identifier);
      },
    };
    this.dialog.open(ConfirmDialogComponent, {
      data: dialogData,
    });
  }

  addNewIdentifier() {
    const newIdentifier = new SupplementaryEquipmentIdentifier({
      active: true,
      identifier: this.newIdentifier,
    });

    this.identifiers.push(newIdentifier);

    this.addNewIdentifierClicked.emit(newIdentifier);

    this.identifiersForm.reset();
  }

  addNewEnabled() {
    return this.identifiersForm.valid;
  }
}


